.kt{min-width:14rem;}